import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 按需注入vant
import "./plugins/vantInstall";

import { Store } from "./store";
import { createPinia, PiniaVuePlugin } from "pinia";
// 创建pinia
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(pinia);
// 全局绑定store
const store = Store();
Vue.prototype.$store = store;

import api from "./util/api";
Vue.prototype.$api = api;
Vue.config.productionTip = false;

import "animate.css";
import "wowjs/css/libs/animate.css";
import wow from "wowjs";
Vue.prototype.$wow = wow;

// 时间处理器
Vue.filter("handleTime", (value) => {
  if (!value) return "";
  return value.split(" ")[0];
});
// 业务模块标题处理器
Vue.filter("handleShowName", (value) => {
  let arr = value.split("-");
  return arr.length > 1 ? arr[1] : value;
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
